'use strict';

var GetIntrinsic = require('../GetIntrinsic');

var originalGetProto = GetIntrinsic('%Object.getPrototypeOf%', true);
var $ArrayProto = GetIntrinsic('%Array.prototype%');
module.exports = originalGetProto || ( // eslint-disable-next-line no-proto
[].__proto__ === $ArrayProto ? function (O) {
  return O.__proto__; // eslint-disable-line no-proto
} : null);